import { useEffect, useRef } from "react";

const FAVICON = '/favicon.png';

function setFavicons(url: string) {
  const existingLinks = document.querySelectorAll(
    'link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]'
  );
  existingLinks.forEach(link => link.remove());

  const cacheBustedUrl = `${url}?v=${Date.now()}`;

  const iconLink = document.createElement("link");
  iconLink.rel = "icon";
  iconLink.type = "image/png";
  iconLink.href = cacheBustedUrl;
  document.head.appendChild(iconLink);

  const shortcutLink = document.createElement("link");
  shortcutLink.rel = "shortcut icon";
  shortcutLink.href = cacheBustedUrl;
  document.head.appendChild(shortcutLink);

  const appleTouchIcon = document.createElement("link");
  appleTouchIcon.rel = "apple-touch-icon";
  appleTouchIcon.href = cacheBustedUrl;
  document.head.appendChild(appleTouchIcon);
}

export function FaviconLoader() {
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!hasInitialized.current) {
      setFavicons(FAVICON);
      hasInitialized.current = true;
    }
  }, []);

  return null;
}
